export class ProfileFormData {
    constructor(_applicantId: number, _pageId:string) {
        this.applicantId = _applicantId;
        this.pageId = _pageId;
    }
    applicantId: number;
    pageId: string;
}
